<script setup>
import PaymentFormCard from "@/components/payments/PaymentFormCard.vue";

defineProps({
  invoiceNo: String,
  invoice: Object,
  invoiceOptions: {
    type: Array,
    default: () => [],
  },
  error: String,
});

defineEmits(["update:invoiceNo"]);

const formatCurrency = (value) => {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
  }).format(value || 0);
};

const formatDate = (value) => {
  if (!value) return "-";
  return new Intl.DateTimeFormat("th-TH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(new Date(value));
};
</script>
<template>
  <PaymentFormCard
    title="เลือกใบแจ้งหนี้"
    subtitle="เลือกรายการใบแจ้งหนี้ที่ต้องการรับชำระเงิน ระบบจะดึงข้อมูลลูกบ้านและยอดคงเหลือให้อัตโนมัติ"
    icon="bi-receipt-cutoff"
  >
    <div class="mb-3">
      <label class="form-label fw-semibold">ใบแจ้งหนี้</label>
      <select
        class="form-select"
        :value="invoiceNo"
        @change="$emit('update:invoiceNo', $event.target.value)"
      >
        <option value="">-- เลือกใบแจ้งหนี้ --</option>
        <option
          v-for="item in invoiceOptions"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </option>
      </select>
      <div v-if="error" class="text-danger small mt-1">{{ error }}</div>
    </div>

    <div v-if="invoice" class="row g-3 mt-1">
      <div class="col-md-6">
        <div class="label-text">ลูกบ้าน</div>
        <div class="value-text">{{ invoice.residentName }}</div>
      </div>
      <div class="col-md-6">
        <div class="label-text">ยูนิต / อาคาร</div>
        <div class="value-text">
          {{ invoice.unitCode }} / {{ invoice.building }}
        </div>
      </div>
      <div class="col-md-6">
        <div class="label-text">รอบบิล</div>
        <div class="value-text">{{ invoice.billingMonth }}</div>
      </div>
      <div class="col-md-6">
        <div class="label-text">ครบกำหนดชำระ</div>
        <div class="value-text">{{ formatDate(invoice.dueDate) }}</div>
      </div>
      <div class="col-md-4">
        <div class="label-text">ยอดทั้งสิ้น</div>
        <div class="value-text">{{ formatCurrency(invoice.totalAmount) }}</div>
      </div>
      <div class="col-md-4">
        <div class="label-text">ชำระแล้ว</div>
        <div class="value-text text-success">
          {{ formatCurrency(invoice.paidAmount) }}
        </div>
      </div>
      <div class="col-md-4">
        <div class="label-text">ยอดคงเหลือ</div>
        <div class="value-text text-danger">
          {{ formatCurrency(invoice.outstandingAmount) }}
        </div>
      </div>
    </div>
  </PaymentFormCard>
</template>

<style scoped>
.label-text {
  font-size: 0.82rem;
  color: #6c757d;
  margin-bottom: 0.25rem;
}

.value-text {
  font-weight: 600;
}
</style>
